module.exports = __webpack_public_path__ + "media/images/plans/plan-ceremony-course-meal-7823198ccfe29dd1cec5d579d78c341b.jpg";